<template lang="pug">
#PartsTable
  b-table(:items="items" :fields="fields" responsive)
    template(#cell(part_number)="value")
      VueBarcode(v-bind:value="ot.rma" width=1 height=30 textAlign="center" fontSize="15")
    template.code(#cell(code)="value")
      VueBarcode(v-model="value.item.part_number" width=1 height=20 textAlign="center" fontSize="13")
    template(#cell(allocated)="value")
      div(v-bind:class="value.item.not_allocated_at_start ? 'text-danger' : 'text-success'") {{value.item.allocated}}
    template(#cell(real_location)="value")
      div {{value.item.real_location }}
    template(#cell(estado)="value")
      span.badge-estado(:class="badgeClass(value.item.estado)") {{ badgeLabel(value.item.estado) }}
    template(#cell(fecha_hora_entrega_estimada)="value")
      b-button.btn-primary.mr-2(
        v-if="value.item.estado === 'Solicitado' && value.item.allocated === 'No'"
        @click="openModalDate(value.item)"
        ) {{ value.item.fecha_hora_entrega_estimada === '-' ? 'Marcar' : 'Editar' }}
      span {{value.item.fecha_hora_entrega_estimada}}
    template(#cell(cancelacion)="value")
      div(v-if="value.item.estado === 'Cancelado'")
        div.text-muted.small {{ value.item.razon_cancelacion_display || '-' }}
        div.text-muted.small(v-if="value.item.fecha_cancelacion") {{ value.item.fecha_cancelacion }}
      span(v-else) -
    template(#cell(acciones)="value")
      span(v-if="value.item.estado === 'Cancelado'") -
      template(v-else)
        b-button.btn-cancelar(
          v-if="value.item.estado === 'Solicitado'"
          @click="openModalCancelar(value.item)"
        ) Cancelar
        RadioButtonSelectState(:value="value.item" :ot="ot")
    template(#cell(llegada)="value")
      b-button(v-if="value.item.estado === 'Solicitado'"  @click="handleChangePart(value.item)") Cambiar
    template(#cell(historial)="value")
      EyeIcon(v-if="value.item.historial.length > 0"  @view-details="showModal(value.item.historial)")
      div(v-if="value.item.historial.length === 0" class="text-center") -
    button.save(@click="saveData" v-if="$route.name !== 'AgregarDiagnostico' && parts !== null") Guardar
  PartCreation(
    :ot="ot"
    :part="partSelected"
    v-if="partSelected"
    v-model="partsCreationModal"
    @closeModal="closeModal"
    @pieza-actualizada="actualizarHistorial(partSelected, $event)"
  )
  b-modal(v-model="showModalFlag" title="Historial de cambios de pieza", size="xl")
    b-table(:items="dataHistorial" :fields="historialFields" responsive bordered)
      template(#cell(date)="value")
        div {{ value.date }}
      template(#cell(action)="value")
        div {{ value.action }}
  SamtekModal(
    v-model="modalDate"
    title="Marcar fecha de llegada"
    size="sm"
    confirmText="Marcar"
    @confirm="handleMarcarLlegada"
  )
    b-form-group(label="Fecha estimada de llegada")
      b-form-input(
        type="date"
        v-model="fecha_estimada"
        :state="fecha_estimada ? true : null"
      )
  SamtekModal(
    v-model="modalCancelar"
    title="Cancelar solicitud de Partes"
    confirmText="Confirmar"
    cancelText="Cancelar"
    :loading="loadingCancelar"
    @confirm="handleCancelPart"
    @cancel="closeCancelarModal"
  )
    div(v-if="itemACancelar")
      .text-center.mb-4
        img(src="@/assets/icon-warning.svg" width="64" alt="advertencia")
      .info-box.mb-4
        p.mb-2 Estás a punto de cancelar la solicitud para:
        p.mb-2
          strong {{ itemACancelar.part_number !== '-' ? itemACancelar.part_number : '' }}
          strong(v-if="itemACancelar.part_number !== '-' && itemACancelar.descripcion !== '-'") &nbsp;- 
          strong {{ itemACancelar.descripcion !== '-' ? itemACancelar.descripcion : '' }}
        p.mb-0
          strong Importante
          | : Esta acción no se puede deshacer y pasará la solicitud a "Cancelada"
      b-form-group
        label.font-weight-bold Motivo*
        b-form-select(
          v-model="razonCancelacion"
          :options="razonesOpciones"
          :state="razonSeleccionada"
        )
        b-form-invalid-feedback Selecciona un motivo para continuar.
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import VueBarcode from 'vue-barcode'
import StatesSelect from './StatesSelect.vue'
import RadioButtonSelectState from './RadioButtonSelectState.vue'
import PartCreation from './PartCreation.vue'
import EyeIcon from './EyeIcon.vue'

export default {
  name: 'PartsTable',
  components: {
    StatesSelect,
    RadioButtonSelectState,
    PartCreation,
    VueBarcode,
    EyeIcon,
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  props: [
    'ot',
    'showStateActionColumn',
    'showArrivalColumn',
    'handleArrival',
    'filterStates',
    'filterAllocated',
  ],
  data() {
    return {
      parts: null,
      partsCreationModal: false,
      droppedRequest: false,
      tecnico: null,
      realLocation: null,
      partSelected: null,
      showModalFlag: false,
      fecha_estimada: null,
      modalDate: false,
      selectedItem: null,
      dataHistorial: [],
      historialFields: [
        { key: 'pieza_original', label: 'Pieza original' },
        { key: 'pieza_nueva', label: 'Pieza Nueva' },
        { key: 'fecha_cambio', label: 'Fecha Cambio' },
      ],
      // Modal cancelar
      modalCancelar: false,
      itemACancelar: null,
      razonCancelacion: null,
      loadingCancelar: false,
      razonesOpciones: [
        { value: null, text: 'Selecciona' },
        { value: 'error_digitacion', text: 'Error de digitación' },
        { value: 'descontinuado', text: 'Repuesto descontinuado' },
      ],
    }
  },
  beforeCreate() {
    const { user } = JSON.parse(localStorage.getItem('user'))
    this.tecnico = user.groups.find((g) => g.name === 'Técnico')
  },
  async created() {
    await this.getAllUsers()
  },
  computed: {
    ...mapGetters('Warehouse', ['allUsers']),
    razonSeleccionada() {
      if (this.razonCancelacion === null) return null
      return this.razonCancelacion ? true : false // eslint-disable-line
    },
    fields() {
      let fields = [
        { key: 'part_number', label: 'Rma' },
        { key: 'code', label: 'Código' },
        { key: 'allocated', label: 'Allocated' },
        { key: 'fecha_hora_solicitud', label: 'Solicitud' },
        { key: 'fecha_hora_entrega', label: 'Entrega' },
        { key: 'descripcion', label: 'Descripción' },
        { key: 'real_location', label: 'Real Location' },
        { key: 'fecha_hora_entrega_estimada', label: 'Entrega Estimada' },
        { key: 'estado', label: 'Estado' },
        { key: 'cancelacion', label: 'Cancelación' },
        { key: 'acciones', label: 'Acciones' },
        { key: 'historial', label: 'Historial' },
      ]
      // eslint-disable-next-line
      fields = fields.filter((f) => {
        if (this.showStateActionColumn === true)
          return f.key !== 'historial' && f.key !== 'cancelacion'
        if (this.showStateActionColumn === false)
          return f.key !== 'acciones' && f.key !== 'fecha_hora_entrega'
        if (this.filterStates) return f.key !== 'acciones'
      })
      if (this.showArrivalColumn) {
        fields = fields
          .concat([{ key: 'llegada', label: 'Acciones' }])
          .filter((f) => f.key !== 'historial' && f.key !== 'cancelacion')
      }
      return fields
    },
    items() {
      return this.ot.solicitud_partes
        ?.filter((parte) => {
          if (this.filterStates && !this.filterAllocated) {
            return parte.allocated === this.filterAllocated
          }
          return true
        })
        .filter((parte) => {
          if (this.filterStates && this.filterStates.length > 0) {
            return this.filterStates.includes(parte.estado)
          }
          return true
        })
        .sort((a, b) => {
          const aCancelado = a.estado === 'Cancelado' ? 1 : 0
          const bCancelado = b.estado === 'Cancelado' ? 1 : 0
          return aCancelado - bCancelado
        })
        .map((parte) => {
          //eslint-disable-line
          const estadosNuevosNombres = {
            Usado: 'Bad',
          }
          return {
            allocated: parte.allocated ? 'Sí' : 'No',
            not_allocated_at_start: parte.not_allocated_at_start,
            part_number: parte.parte ? parte.parte.part_number : '-',
            fecha_hora_solicitud: parte.fecha_hora_solicitud
              ? moment(parte.fecha_hora_solicitud).format('DD-MM-YYYY HH:mm')
              : '-',
            fecha_hora_entrega: parte.fecha_hora_entrega
              ? moment(parte.fecha_hora_entrega).format('DD-MM-YYYY HH:mm')
              : '-',
            fecha_hora_entrega_estimada: parte.fecha_hora_entrega_estimada
              ? moment(parte.fecha_hora_entrega_estimada).format('DD-MM-YYYY')
              : '-',
            code: parte.parte ? parte.parte.part_number : '',
            descripcion: parte.parte ? parte.parte.description : '-',
            real_location: parte.parte ? parte.parte.real_location : '-',
            estado: estadosNuevosNombres[parte.estado]
              ? estadosNuevosNombres[parte.estado]
              : parte.estado,
            razon_cancelacion_display: parte.razon_cancelacion_display || null,
            fecha_cancelacion: parte.fecha_cancelacion
              ? moment(parte.fecha_cancelacion).format('DD-MM-YYYY HH:mm')
              : null,
            id: parte.id,
            historial: parte.registro,
          }
        })
    },
  },
  methods: {
    ...mapActions('Diagnosticos', [
      'updateRequests',
      'cancelPart',
      'markDateArrival',
    ]),
    ...mapActions('Warehouse', ['getAllUsers']),
    ...mapActions('Notifications', ['sendNotification']),
    rowClass() {
      return ''
    },
    badgeClass(estado) {
      const map = {
        Solicitado: 'badge-pendiente',
        'En espera': 'badge-pendiente',
        Localizado: 'badge-notificada',
        Entregado: 'badge-entregado',
        Cancelado: 'badge-cancelada',
        Bad: 'badge-default',
      }
      return map[estado] || 'badge-default'
    },
    badgeLabel(estado) {
      const labels = {
        Solicitado: 'Pendiente',
        'En espera': 'Pendiente',
        Localizado: 'Notificada',
        Entregado: 'Entregado',
        Cancelado: 'Cancelada',
      }
      return labels[estado] || estado
    },
    getPartColor() {
      return 'color: #253590; font-weight: bold;'
    },
    openModalDate(item) {
      this.selectedItem = item
      if (item.fecha_hora_entrega_estimada !== '-') {
        this.fecha_estimada = moment(item.fecha_hora_entrega_estimada).format(
          'YYYY-MM-DD'
        )
      } else {
        this.fecha_estimada = null
      }
      this.modalDate = true
    },
    async handleMarcarLlegada() {
      if (!this.fecha_estimada) {
        this.$bvToast.toast('Seleccione una fecha estimada', {
          variant: 'danger',
        })
        return
      }
      const response = await this.markDateArrival({
        ot_id: this.ot.ot,
        solicitud_id: this.selectedItem.id,
        fecha_estimada: this.fecha_estimada,
      })
      if (response.status !== 200) {
        this.$bvToast.toast('Error al marcar la fecha de llegada', {
          variant: 'danger',
        })
        return
      }
      const newItem = response.data
      this.selectedItem.fecha_hora_entrega_estimada = moment(
        newItem.fecha_hora_entrega_estimada
      ).format('DD-MM-YYYY')
      this.$bvToast.toast('Fecha de llegada marcada', {
        variant: 'success',
      })
      this.fecha_estimada = null
      this.modalDate = false
    },
    handleChangePart(part) {
      this.partsCreationModal = true
      this.partSelected = part
      console.log('change part', part)
    },
    closeModal() {
      this.partsCreationModal = false
      console.log('close modal')
    },
    actualizarHistorial(item, nuevoHistorial) {
      if (item.historial) {
        item.historial.push(nuevoHistorial)
      } else {
        this.$set(item, 'historial', nuevoHistorial)
      }
    },
    async saveData() {
      const data = []
      this.items.forEach((item) => {
        data.push({
          ot: this.ot.ot,
          solicitudId: item.id,
          parte: {
            partNumber: item.part_number,
            description: item.descripcion,
            realLocation: item.real_location,
          },
          allocated: item.allocated === 'No' ? false : true, //eslint-disable-line
        })
      })
      const resp = await this.updateRequests(data)
      if (resp && resp.status === 200) {
        this.$bvToast.toast(`${resp.data}`, {
          variant: 'success',
        })
        this.sendPartNotification()
      }
    },
    async sendPartNotification() {
      const users = this.allUsers.filter((u) => {
        //eslint-disable-line
        return u.groups.find((g) => g.name === 'Bodega')
      })
      const userIds = users?.map((u) => u.id)
      userIds.push(this.ot.tecnico_asignado.id)
      const anyAllocated = this.items.find(
        (p) => p.estado_pieza === 'Localizado'
      )
      if (anyAllocated) {
        const notificationData = {
          recipients: userIds,
          ot: this.ot.ot,
          message: 'Llegó parte solicitada',
          send_by_email: false,
          type_message: 2,
        }
        const rsp = await this.sendNotification(notificationData)
        console.log(rsp)
      }
      this.parts = []
    },
    openModalCancelar(item) {
      this.itemACancelar = item
      this.razonCancelacion = null
      this.modalCancelar = true
    },
    closeCancelarModal() {
      this.modalCancelar = false
      this.itemACancelar = null
      this.razonCancelacion = null
    },
    async handleCancelPart() {
      if (!this.razonCancelacion) {
        this.$bvToast.toast('Selecciona una razón de cancelación.', {
          variant: 'danger',
        })
        return
      }
      this.loadingCancelar = true
      try {
        const resp = await this.cancelPart({
          otId: this.ot.ot,
          parte_solicitada_id: this.itemACancelar.id,
          razon: this.razonCancelacion,
        })
        if (resp && resp.status === 200) {
          this.$bvToast.toast('Solicitud de parte cancelada.', {
            variant: 'success',
          })
          this.closeCancelarModal()
          this.$emit('changed')
        } else {
          const msg =
            resp && resp.data ? resp.data : 'Error al cancelar la parte.'
          this.$bvToast.toast(msg, { variant: 'danger' })
        }
      } finally {
        this.loadingCancelar = false
      }
    },
    showModal(historial) {
      if (historial.length > 0) {
        this.dataHistorial = historial
          .sort((a, b) => new Date(b.fecha_cambio) - new Date(a.fecha_cambio))
          .map((pieza) => ({
            pieza_original: pieza.pieza_original.part_number,
            pieza_nueva: pieza.pieza_nueva.part_number,
            fecha_cambio: moment(pieza.fecha_cambio).format('DD-MM-YYYY HH:mm'),
          }))
        this.showModalFlag = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .table-responsive {
  height: 40vh;
}
.save {
  color: #fff;
  background-color: #5b73e8;
  border-color: #5b73e8;
  width: 120px;
  height: 45px;
  border-radius: 5px;
  font-weight: 600;
}

// Botón Cancelar — azul oscuro igual al resto de acciones del sistema
.btn-cancelar {
  background-color: #253590;
  border-color: #253590;
  color: #fff;
  border-radius: 8px;
  font-weight: 500;

  &:hover {
    background-color: #1c2870;
    border-color: #1c2870;
  }
}

// Badge de estado
::v-deep .badge-estado {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  color: #fff !important;

  &.badge-pendiente {
    background-color: #f5a54a;
  }
  &.badge-notificada {
    background-color: #3cc8a1;
  }
  &.badge-entregado {
    background-color: #26de81;
  }
  &.badge-cancelada {
    background-color: #e84444;
  }
  &.badge-default {
    background-color: #868e96;
  }
}
// Info box del modal — borde gris, texto descriptivo
::v-deep .info-box {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 16px;
  font-size: 14px;
  line-height: 1.5;
}
</style>
